import { render, staticRenderFns } from "./DesignSize.vue?vue&type=template&id=8500acd0&scoped=true&"
import script from "./DesignSize.vue?vue&type=script&lang=js&"
export * from "./DesignSize.vue?vue&type=script&lang=js&"
import style0 from "./DesignSize.vue?vue&type=style&index=0&id=8500acd0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8500acd0",
  null
  
)

export default component.exports